export default __webpack_public_path__ + "static/media/0148.9c29e22a.jpg";